import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'seagull';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
export const AddTimeActivityButton = (param)=>{
    let { timeActivity, onClick: handleClick } = param;
    const { logBI } = useStoreActions();
    const userId = useStore(selectors.user.id);
    const vendorId = useStore(selectors.user.businessId);
    return /*#__PURE__*/ _jsx(Button, {
        onClick: ()=>{
            logBI(12016, {
                vendorId,
                userId
            });
            handleClick();
        },
        testId: "time-activity-".concat(timeActivity.id, "-add"),
        children: "Add"
    });
};
